import React from 'react';
import {SectionHeader} from '../section/SectionHeader/SectionHeader';
import css from './MobileApp.module.scss';
import {Section} from '../section/Section';
import {SETUP_STEP_TYPES} from '../../../setupSteps/SetupStepTypes';

export const MobileAppSection: React.FC<{
  type: SETUP_STEP_TYPES;
}> = ({type}) => {
  return (
    <Section type={type}>
      <SectionHeader
        title="Install mobile app"
        text="Download the Pulsoid mobile app to capture heart rate data from your heart rate monitor via Bluetooth. Follow further instructions in the app."
      ></SectionHeader>
      <div className={css.section_mobile_app}>
        <div className={css.header_container}>
          <div className={css.title_container}>
            <div className={css.logo_container}>
              <img
                className={css.logo_image}
                src="https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/pulsoid-index/pulsoid-logo.png"
              ></img>
            </div>
            <div>
              <div className={css.title}>
                Pulsoid <span className={css.title_description}>· Free</span>
              </div>
              <div className={css.header_description}>
                Scan QR-code or get the app on App Store or Google Play.
              </div>
            </div>
          </div>
          <div className={css.apps_container}>
            <a href="https://pulsoid.net/s/ios-app" target="_blank">
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="40" height="40" rx="10" fill="#292931" />
                <path
                  d="M25.6807 19.1566C25.7102 22.3346 28.4686 23.3922 28.4991 23.4057C28.4758 23.4802 28.0584 24.9128 27.0459 26.3925C26.1706 27.6717 25.2622 28.9463 23.8312 28.9727C22.425 28.9986 21.9729 28.1389 20.3653 28.1389C18.7582 28.1389 18.2558 28.9463 16.9248 28.9986C15.5435 29.0509 14.4916 27.6153 13.6091 26.3407C11.8057 23.7335 10.4275 18.9733 12.2781 15.7601C13.1973 14.1645 14.8402 13.154 16.6234 13.1281C17.9798 13.1022 19.26 14.0406 20.0892 14.0406C20.9179 14.0406 22.4737 12.9121 24.1093 13.0779C24.794 13.1064 26.716 13.3544 27.9501 15.1609C27.8507 15.2226 25.6568 16.4997 25.6807 19.1566ZM23.038 11.353C23.7714 10.4653 24.2649 9.22955 24.1303 8C23.0732 8.04248 21.795 8.70439 21.0368 9.59159C20.3573 10.3772 19.7622 11.6347 19.9228 12.8399C21.101 12.9311 22.3046 12.2412 23.038 11.353Z"
                  fill="white"
                />
              </svg>
            </a>
            <a href="https://pulsoid.net/s/android-app" target="_blank">
              <svg
                width="40"
                height="40"
                viewBox="0 0 40 40"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <rect width="40" height="40" rx="10" fill="#292931" />
                <path
                  d="M20.6756 19.5413L12.0762 28.5509C12.1727 28.8931 12.3463 29.2088 12.5835 29.4737C12.8207 29.7386 13.1154 29.9457 13.445 30.0793C13.7745 30.2128 14.1303 30.2692 14.485 30.2442C14.8397 30.2192 15.184 30.1135 15.4916 29.935L25.1676 24.4242L20.6756 19.5413Z"
                  fill="#EA4335"
                />
                <path
                  d="M29.3688 18.0098L25.1845 15.6133L20.4746 19.7464L25.2037 24.4114L29.356 22.0404C29.7239 21.8478 30.032 21.5582 30.247 21.2029C30.462 20.8477 30.5757 20.4404 30.5757 20.0251C30.5757 19.6099 30.462 19.2026 30.247 18.8473C30.032 18.4921 29.7239 18.2024 29.356 18.0098H29.3688Z"
                  fill="#FBBC04"
                />
                <path
                  d="M12.0769 11.4545C12.0249 11.6467 11.9991 11.845 12 12.044V27.9614C12.0005 28.1604 12.0264 28.3585 12.0769 28.5509L20.9712 19.772L12.0769 11.4545Z"
                  fill="#4285F4"
                />
                <path
                  d="M20.7397 20.0027L25.1868 15.6133L15.5236 10.0768C15.1601 9.8639 14.7467 9.75114 14.3254 9.75C13.8166 9.749 13.3214 9.91439 12.9153 10.221C12.5092 10.5275 12.2146 10.9585 12.0762 11.4481L20.7397 20.0027Z"
                  fill="#34A853"
                />
              </svg>
            </a>
          </div>
        </div>
        <div className={css.qr_code_container}>
          <img
            className={css.qr_code}
            src="https://pulsoid-magi.nyc3.cdn.digitaloceanspaces.com/pages-content/setup-wizard/mobile-app-qr.png"
          />
          <div className={css.qr_code_description}>
            Scan with camera on your phone to install Pulsoid app
          </div>
        </div>
      </div>
    </Section>
  );
};
